import {
    apiRequest,
    periodeVerifikasiCreate,
    employeeListcreate,
    polaKerjaList
} from "../../../../../services/adapters/kepegawaian/periodeVerifikasiService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", periodeVerifikasiCreate, {
            body: query
        }, true)
    }

    fetchEmployee = async (query) => {
        return await apiRequest("get", employeeListcreate, {
            params: query
        }, true)
    }

    fetchPolaKerja = async (query) => {
        return await apiRequest("get", polaKerjaList, {
            params: query
        }, true)
    }
}

export default CreateRepository